module.exports = __webpack_public_path__ + "img/sankaku_49_blue.46e96271.png";